import { OPTIMIZELY } from 'services/actions/optimizelyActions';

export const optimizelyInitialState = [];

// we are not currently storing Optimizely data in the store but may do so in the future
export function optimizelyReducer(state = optimizelyInitialState, action) {
  switch (action.type) {
    case OPTIMIZELY.SET_OPTIMIZELY_SETTING: {
      return [...state, ...action.payload];
    }

    default: {
      return state;
    }
  }
}

export default optimizelyReducer;
